<template>
  <div class="wrapper box box_v">
    <div class="header box">
      <div class="box_f1 titlecen">通知中心</div>
      <div class="box box_v read pointer" @click="readAll">
        <div class="h74">
          <i class="iconfont icon-yidu-" style="font-size: 20px;"></i>
          全部已读
        </div>
      </div>
    </div>
    <div class="box_f1 not-con">
      <div
        class="notice box"
        v-for="(item, index) in noticeList"
        :key="index"
        @click="goDetail(index)"
      >
        <img :src="item.pic" class="not-pic box" alt v-if="item.pic"/>
        <div class="box_f1">
          <div class="n-tit">{{item.title}}</div>
          <div class="n-tim">{{item.time}}</div>
        </div>
        <div class="box_v" style="justify-content: center" v-if="item.isRead == 0">
          <i class="point"></i>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="p-con">
        <Page :total="sysTotal" :page-size="6" show-total :current="page" @on-change="pageChange" />
      </div>
    </div>
    <Spin fix v-if="loading"></Spin>
  </div>
</template>

<script>
export default {
  data() {
    return {
      noticeList: [],
      loading: false,
      page: 1,
      pageSize: 6,
      sysTotal: 0
    };
  },
  methods: {
    getNoticeList() {
      this.loading = true;
      var data = {
        pageNum: this.page,
        pageSize: this.pageSize
      };
      this.$post(this.urlobj.sysNoticeList, data)
        .then(res => {
          let list = res.rows.map(item => {
            return {
              title: item.title,
              id: item.id,
              time: item.createTime.substring(0, 10),
              pic: item.coverPicUrl,
              isRead: item.isRead
            };
          });
          this.sysTotal = res.total
          this.noticeList = list;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    readAll() {
      this.loading = true;
      this.$post(this.urlobj.readAll)
        .then(res => {
          if (res.isSucceed) {
            this.$Message.success("操作成功");
            this.getNoticeList();
          }
          this.loading=false
        })
        .catch(e => {
          console.log("shibai");
          this.loading = false;
          this.$Message.warning(res.message);
        });
    },
    goDetail(index) {
      console.log(this.noticeList[index].id);
      this.$router.push({
        name: "sysNotDetail",
        query: { id: this.noticeList[index].id }
      });
    },
    pageChange(val) {
      this.page = val
      this.getNoticeList()
    }
  },

  mounted() {
    this.page = 1
    this.getNoticeList();
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  height: 100%;
  justify-content: center;
}
.not-con {
  height: 100%;
  width: 750px;
  padding: 0 40px;
  background: #fff;
  margin: auto;
}
.header {
  width: 750px;
  margin: 0 auto;
  height: 74px;
  line-height: 74px;
}
.titlecen {
  font-size: 24px;
  color: #666;
}
.read {
  color: #677a9e;
  font-size: 20px;
}
.h74 {
  height: 74px;
}
.notice {
  padding: 30px 0;
  border-bottom: 1px solid #e1e1e1;
}
.notice:nth-last-child(1){
  border-bottom: none
}
.not-pic {
  width: 152px;
  height: 102px;
  margin-right: 20px;
}
.n-tit {
  font-size: 22px;
  color: #4b4b4b;
}
.n-tim {
  font-size: 16px;
  color: #999;
  margin-top: 30px;
}
.point {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff2626;
}
.page {
  width: 750px;
  margin: auto;
  background: #fff;
  padding: 20px 0;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e1e1e1;
}
.p-con {
  margin-right: 50px;
  margin-top: 70px;
}
</style>